//
//
//
//
//
//
//
//
//
//
import scrollama from 'scrollama';
export default {
  name: 'MdmParallax',
  props: {
    offset: {
      type: Number,
      required: true
    },
    step: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      scroller: null,
      status: {}
    };
  },

  computed: {
    stickyStyle() {
      return "transform: translate3d(-".concat(this.status.progress * 100, "%, 0px, 0px)");
    }

  },

  created() {
    this.scroller = scrollama();
  },

  mounted() {
    this.scroller.setup({
      offset: this.offset,
      step: this.step,
      graphic: '.graphic',
      progress: true,
      debug: false
    }).onStepProgress(this.handleStepProgress); // setup resize event

    this.$nextTick(() => {
      this.resize();
    });
    window.addEventListener('resize', this.resize, {
      passive: true
    });
  },

  destroyed() {
    window.removeEventListener('resize', this.resize);
  },

  methods: {
    resize() {
      this.scroller.resize();
    },

    handleStepProgress(response) {
      this.status = response;
    }

  }
};